export const SET_OFFICE_WORK_MONTH_DATE =
  "PAGES/OFFSITE_WORK/OFFICE_WORK_MONTH/SET_DATE";

export interface State {
  offsiteWorkMonthDate: string;
}
